import { render, staticRenderFns } from "./patientSystemParams.vue?vue&type=template&id=208f37d4&scoped=true"
import script from "./patientSystemParams.vue?vue&type=script&lang=js"
export * from "./patientSystemParams.vue?vue&type=script&lang=js"
import style0 from "./patientSystemParams.vue?vue&type=style&index=0&id=208f37d4&prod&lang=less&scoped=true"
import style1 from "./patientSystemParams.vue?vue&type=style&index=1&id=208f37d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f37d4",
  null
  
)

export default component.exports